export default "__VITE_ASSET__CvSrx7Ul__"